// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recommend-list[data-v-e23037f8]{margin:0;z-index:3000;position:fixed;text-align:left;-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.32);background-color:#fff;padding-top:7px;padding-bottom:7px}.recommend-item[data-v-e23037f8]{z-index:3000;height:30px;width:100%;padding:5px 10px 5px 10px}.onselect[data-v-e23037f8]{background-color:#eaebee}.text-bold[data-v-e23037f8]{font-weight:700}", ""]);
// Exports
module.exports = exports;
